import { ContactUsConfirmation } from 'components/contactUs/contactUsConfirmation';
import ContactUsForm from 'components/contactUs/contactUsForm';
import { useState } from 'react';

export default function ContactUs() {
  const [submitted, setSubmitted] = useState(false);
  return <>{!submitted ? <ContactUsForm setSubmitted={setSubmitted} /> : <ContactUsConfirmation />}</>;
}
